var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon-info-circle-fill',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.html",value:(_vm.text),expression:"text",modifiers:{"hover":true,"html":true}}],attrs:{"font-scale":_vm.fontScale}})
}
var staticRenderFns = []

export { render, staticRenderFns }